// @core/api/endpoints/fiscalization/test_fiscal_provider.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  TestFiscalProviderRequest,
  TestFiscalProviderResponse,
} from '../../../types/fiscalization';

const BASE_PATH = '/fiscalization';

/**
 * Test fiscal provider connection
 * Tests connectivity and authentication with the fiscal provider API. Returns success status and provider version info.
 */
export async function TestFiscalProvider(
  id: string,
  data: TestFiscalProviderRequest,
  options?: RequestOptions
): Promise<TestFiscalProviderResponse> {
  const client = getApiClient();
  let requestPath = `${BASE_PATH}/fiscal-providers/:id/test`;
  requestPath = requestPath.replace(':id', encodeURIComponent(id));
  const requestOptions = options;
  return client.post<TestFiscalProviderResponse>(requestPath, data, requestOptions);
}
